module.exports = {
      id: "fb-whitebg-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-94c0c4e617ccd395a266f9fdfc4a2687.svg#fb-whitebg",
      toString: function () {
        return this.url;
      }
    }